export default __webpack_public_path__ + "static/assets/med_pill_elipse_in_L1_solid_x_01_f.de447922.png";